var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ais-instant-search',{attrs:{"index-name":this.paramProp['indexes']['job'],"search-client":_vm.searchClient}},[_c('AutoComplete',{attrs:{"page":"home","param-prop":_vm.params}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }